import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { notifyError, notifySuccess } from "../utils/toast";
import { useNavigate } from "react-router-dom";
import { handleLoginUser } from "../services/userService";
import axios from "axios";
import { apiUrl } from "../Apis/config";
import LoginApi from "../Apis/LoginApi";

const useLogin = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible , setVisible] = useState(false)

  const handleLogin = async (data) => {
  
    try {
      setLoading(true);
  
      const body = {
        emailId: data.email,
        password: data.password,
      };
  
      const response = await handleLoginUser(body)
      console.log(response);
  
      if (response?.user) {
      
        localStorage.setItem("userDetails", JSON.stringify(response?.user));
  
       
        window.location.reload();
  
        navigate("/home");

        notifySuccess(response?.message);
      } 
    } catch (error) {
      console.error(error);
      notifyError("You are not authorized to access this application");
    } finally {
      setLoading(false);
    }
  };

  const handleResetToggle =()=>{
    reset()
    setVisible(!visible)
  }

const handleResetPassword   =async (data)=>{
  console.log("Reset")
  setLoading(true)
try{
  const body ={
email : data.email
  }
  const response = await axios.post(`${apiUrl}/reset-password` , body)
  console.log(response)
  notifySuccess(response?.data)


}catch(error){
  console.log(error)

  notifyError(error?.response?.data)
}finally{
  setLoading(false)
}
}

const  handleManageLogin = (data)=>{
 

  if(visible){
    handleResetPassword(data)
  }else{
    handleLogin(data)
  }

}
  
  
  
  return {
    isLogin,
    setIsLogin,
    loading,
    setLoading,
    handleLogin,
    register,
    handleSubmit,
    errors,
    reset,
    handleResetPassword,
    handleResetToggle,
    visible,
    setVisible,
    handleManageLogin
  };
};

export default useLogin;
